export default __webpack_public_path__ + "static/media/it-3.43c9e0dc.svg";